<template>
  <div>
    <!--头部当前城市、酒店搜索-->
    <div class="search-condition">
      <div class="search-condition-item">
        <div class="search-condition-city">
          <div @click="showCitySelection(!defaultIndex)" class="cursor-pointer">
            <i class="el-icon-location-outline"></i>
            <span>{{searcValue.cityName}}</span>
            <i class="el-icon-arrow-down" :class="{'active': defaultIndex==1}"></i>
          </div>
          <CitySelection class="citySelection"  v-show="defaultIndex==1" :infoLise="infoLise" @formData="formData" :searcValue="searcValue" :adjust="true"></CitySelection>
        </div>
        <div class="search-condition-line"></div>
          <div class="search-wrap">
            <el-autocomplete
              class="inline-input"
              v-model="searcValue.title"
              :fetch-suggestions="querySearchAsync"
              placeholder="搜索酒店品牌或名称..."
              :trigger-on-focus="false"
              @select="handleSelect"
              @focus="inputFocus"
              @blur="handleBlur"
              prefix-icon="el-icon-search"
            >
            <template slot-scope="{ item }">
              <!-- v-html 必须用，渲染包裹的span标签 -->
              <span class="iconfont icon-ruzhugongsi"></span>
              <span class="mr-2"  v-if="item.flag">{{item.city| obtainProvince()}}</span>
              <span v-html="$verify.highlightKeyword(item.title, searcValue.title)"></span>
            </template>
            </el-autocomplete>
            <el-button type="primary" class="bottom" icon="el-icon-search" @click="refreshList()">立即搜索</el-button>
          </div>
      </div> 
    </div>
     <!--分类搜索整合-->
     <div class="classification-Set">
        <!--地理位置筛选-->
        <Location  @inform="inform"  :searcValue="searcValue"></Location>
        <!--酒店星级筛选-->
        <Classification @inform="inform" title="酒店星级" :isMulti="true" :searcValue="searcValue" valueKey="star" :list="$GVAR.HotelStar.slice(2,9)"></Classification>
        <!--住宿类型筛选-->
        <Classification @inform="inform" title="住宿类型"  :searcValue="searcValue" valueKey="type" :list="$GVAR.StyleLabel"></Classification>
        <!--双床房筛选-->
        <Classification @inform="inform" @customize="customize" title="酒店双床房"  :searcValue="searcValue" valueKey="room_2_type" :list="$GVAR.twinRoomQuantity"></Classification>
        <!--酒店首字母-->
        <Classification @inform="inform" title="酒店首字母"  :searcValue="searcValue" valueKey="pinyin" :list="$GVAR.SearchInitialList"></Classification> 
        <!--酒店品牌  -->
        <Classification @inform="inform" title="酒店品牌" :searcValue="searcValue" valueKey="brand" :list="Hotelbrandlist"></Classification>
        <!--登录遮罩-->
        <div class="login-mask" @click="$router.push({name:'userLogin'})" v-if="!userLoginMessage.token"></div>
     </div>
     <!--已搜索条件-->
     <SearchCriteria @inform="inform" :searcValue="searcValue" v-if="hasSearchCondition()" @learConditions="formData"></SearchCriteria>
  </div>
</template>

<script>
import CitySelection from '@/views/HomePage/IndexComps/IndexPage/Components/CitySelection.vue'
import Location from './Components/Location.vue'
import Classification from './Components/Classification.vue'
import SearchCriteria from './Components/SearchCriteria.vue'
import {mapActions,mapState} from 'vuex'
export default {
  components: {
    CitySelection,
    Location,
    Classification,
    SearchCriteria
  },
  props: {},
  data() {
    return {
        restaurants: [],
        infoLise:{},
        defaultIndex:0,
        //搜索框的值
        searcValue: {
          cityName:'杭州',                //当前城市名称
          cityId:'940',                   //当前城市ID
          cityType:'',                   //当前城市类型
          title:'',                      //搜索酒店名称
          id:'',                         //搜索酒店ID
          district:'',                   //行政区域
          star:[],                       //搜索星级
          isCustom:false,                //是否自定义
          room_2_type:'',                //搜索房间数量
          lon_lat:'',                    //经纬度
          lon_latName:'',                //经纬度名称
          type:'',                       //住宿类型
          pinyin:'',                     //酒店首字母
          brand:'',                      //酒店品牌
        },
        //热门酒店品牌
        Hotelbrandlist:[
          { id: '23', name: '恒大集团'},{ id: '70', name: '万豪(Marriott)'},{ id: '71', name: '万达酒店及度假村'},{ id: '3', name: '百乐酒店集团'},{ id: '19', name: '格林酒店集团'}, { id: '1', name: '安缦(Aman Resorts)'},{ id: '52', name: '明宇集团'},
          { id: '25', name: '汉爵集团'},
        ],
    };
  },
  computed: {
       ...mapState(['SearchInitialList','userLoginMessage']),
  },
  watch: {
      searcValue: {
        handler(val) {
          // 直接取 title
          let titleVal = (val.title || '').trim()
          // 赋值回输入框（避免空格显示）
          this.searcValue.title = titleVal
        },
        deep: true
      },
  },
  created() {},
  mounted() {
    this.getHotCity();
  },
  methods: {
    ...mapActions(['POST_SearchDocHotel','POST_GetAllCity','GetInitialList']),
        // 从 URL 读取筛选条件
      initFilterFromRoute() {
        const query = this.$route.query;
        delete query.city;
        console.log(query);
        if(query){
          this.searcValue={
            ...this.searcValue,
            ...query,
            star:query.star?query.star.split(','):[],
          }
        }
        this.refreshList();
      },
      //-------------------------
      //城市搜索方法
      //-------------------------
      //开启城市选择器
      showCitySelection(index){
        this.defaultIndex=index;
        this.$emit('mask',this.defaultIndex);
      },
      //搜索框的建议列表
      async querySearchAsync(queryString, cb) {
        //内容不等于空字符串
        if (queryString.trim() === '') {
          cb([]);
          return;
        };
        let res= await this.POST_SearchDocHotel({data:{title: queryString,city:this.searcValue.cityId}});
        this.timeout = setTimeout(() => {
          cb(res.list);
        }, 2000 * Math.random());
      },
      //点击搜索框的建议项-跳转详情
      handleSelect(item) {
        this.$emit('viewDetails',item);
        // let changeRoute = this.$router.resolve('/index_hotel/hotel_detail/' + item.id);
        // window.open(changeRoute.href, '_blank');
        // this.searcValue={...this.searcValue,...item}
      },
      //获取热门城市列表
      async getHotCity(){
          let res = await this.POST_GetAllCity({});
          this.infoLise = res;
          //获取酒店、民宿首字母数组
          // this.GetInitialList({ type:'hotel', el: '.load-area' });
      },
      //获取城市信息
      formData(res){
        this.searcValue={
          ...this.searcValue,
          ...res,
          cityType:'',                   //当前城市类型
          title:'',                      //搜索酒店名称
          id:'',                         //搜索酒店ID
          district:'',                   //行政区域
          star:[],                       //搜索星级
          isCustom:false,                //是否自定义
          room_2_type:'',                //搜索房间数量
          lon_lat:'',                    //经纬度
          lon_latName:'',                //经纬度名称
          type:'',                       //住宿类型
          pinyin:'',                     //酒店首字母
          brand:'',                      //酒店品牌
        };
        //清空搜索
        if(res==1){
          this.refreshList();
          return;
        }
        //关闭
        this.defaultIndex=0;
        this.$emit('mask',this.defaultIndex);
        //调用刷新
        this.refreshList();
      },
      //用户点击了输入框
      inputFocus() {
        //关闭所有展开
        this.defaultIndex=0;
        this.$emit('mask',true);
      },
      //用户失去焦点
      handleBlur(){
        this.$emit('mask',false);
      },
      //-------------------------
      //分类方法搜索
      //-------------------------
      //点击分类
      inform(key,value,isMulti=false){
        //多选
        if(isMulti){
          //不存在添加、存在删除
          if(!this.searcValue[key].includes(value)){
            this.searcValue[key].push(value);
          }
          else{
            this.searcValue[key]=this.searcValue[key].filter(item=>item!==value);
          } 
        }
        //单选
        else{
          //如果是双床房区间，需要特殊处理
          if(key=='room_2_range'){
            this.searcValue.room_2_range='';
          }
          //如果是数组则循环值
          if(Array.isArray(key)){
            key.map(item=>{
              this.searcValue[item.key]=item.date||'';
            })
          }else{
            this.searcValue[key]=value||'';
          }
        }
        if(key.length>0 && key[0].key!='cityType'&& key[0].key!='isCustom'){
          //调用刷新
          this.refreshList();
        }
      },
      //刷新酒店列表
      refreshList(){
        this.$emit('searchFtion',this.searcValue);
      },
      //自定义双床房区间
      customize(key,value){
        this.searcValue.room_2_type='';
        this.searcValue[key]=value||'';
      },
      // 判断是否有筛选条件（永不报错）
      hasSearchCondition() {
        let obj = {...this.searcValue};
        //删除值
        delete obj.cityName;
        delete obj.cityId;
        delete obj.title;
        delete obj.cityType;
        delete obj.isCustom;
        return Object.values(obj).some(v => 
          (typeof v === 'string' && v.trim()) ||
          (typeof v === 'number' && !isNaN(v)) ||
          (Array.isArray(v) && v.length)
        )
      }
      }
};
</script>

<style lang="scss" scoped>
  .search-condition{
    text-align: left;
    width: 100%;
    background-color: #fff;
    padding: 4px 0;
    position: fixed;
    top: 80px;
    left: 0;
    z-index: 9;
    box-shadow: 0px 0px 7px #eee;
  }
  .search-condition-item{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content:left;
  }
  .search-condition-city{
    margin: 0 auto;
    width: 14%;
    height: 50%;
    background-color: #f9fafb;
    margin-top: 20px;
    text-align: center;
    border-radius: 6px;
    border: 1px #eee solid;
    height: 40px;
    line-height: 40px;
    position: relative;
    span{
      padding: 0 6%;
      display: inline-block;
    }
    .el-icon-location-outline{
      color: var(--smtc-color-primary);
    }
    .el-icon-arrow-down{
      color: #999;
    }
  }
  .search-wrap{
    width: 94%;
    margin: 20px auto;
    display: flex;
    justify-content: space-between;
  }
  .quickSearch-category{
    display: flex;
    position: relative;
    width: 94%;
    margin: 0 auto;
    color: #Fff;
  }
  .inline-input{
    width: 86%;
  }
  .search-condition-line{
    height: 36px;
    background-color: #e5e7eb;
    width: 1px;
    margin: 0 16px;
    margin-top: 22px;
  }
  .citySelection{
    margin-top: -10px;
  }
  .search-condition-city i{
    transition: transform 0.3s ease; /* 平滑旋转 */
  }
  /* 旋转90度（向右） */
  .search-condition-city .active {
    transform: rotate(180deg);
  }
  //-------------------------
  //分类搜索整合
  //-------------------------
  .classification-Set{
    width: 1160px;
    padding: 20px;
    margin: 0 auto;
    background-color: #fff;
    box-shadow: 0px 0px 7px #eee;
    margin-top: 20px;
    border: 1px #eee solid;
    border-radius: 6px;
    margin-top: 106px;
    position: relative;
    overflow: hidden;
  }
  .mask{
    position: fixed;
    width: 100%;
    background-color: #000;
    height: 90vh;
    left: 0;
    top: 170px;
    z-index: 6 ;
  }
  .login-mask{
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 6;
    height: 100%;
    cursor: pointer;
  }
  .icon-ruzhugongsi{
    font-size: 14px;
    margin-right: 6px;
  }
</style>
<style>
  .inline-input .el-input__inner{
    background-color: #f9fafb;
    border: 1px #eee solid !important;
  }
</style>
